import { useEffect } from 'react';
import { useNoteSetupContext } from 'shared/features/note-setup';
import { useNoteForPathContext } from '../contexts';
export var useExistingNoteRedirect = function () {
    var data = useNoteSetupContext().data;
    var _a = useNoteForPathContext(), noteId = _a.noteId, setNoteId = _a.setNoteId;
    useEffect(function () {
        var _a;
        // there's a render order thing going on here where react-hook-form throws a warning to use navigate in a 
        // useEffect and it doesn't work without the setTImeout, even though it obviously is in a useEffect
        if (((_a = data === null || data === void 0 ? void 0 : data.existingNote) === null || _a === void 0 ? void 0 : _a.id) && !noteId) {
            setTimeout(function () { var _a; return setNoteId((_a = data.existingNote.id) !== null && _a !== void 0 ? _a : '', data.appointment.id); });
        }
    }, [data, noteId]);
};
